module.exports = __webpack_public_path__ + "files/2794ee98bb26d9d1db0ebb9c3396cd38.png";